module.exports = __webpack_public_path__ + "img/icon_anzhuang@2x.1123ae0d.png";